import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Investments = () => {
  return (
    <div className="container-fluid p-5">
      <div className="row">
        <div className="col-md-12 text-center">
          <h1 className="mb-4 text-success">All About Investments</h1>
          <p className="lead">
            Investment is the act of allocating money or resources to an asset with the expectation of generating an income or profit. It plays a key role in building long-term wealth and achieving your financial goals.
          </p>
          <img 
            src="./invest1.jpeg" 
            alt="Investment Planning" 
            className="img-fluid rounded shadow mt-3 mb-5"
          />
        </div>
      </div>

      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-primary">What is an Investment?</h3>
          <p>
            An investment involves putting capital to work, in the form of time, money, effort, etc., with the goal of increasing future value. Investments can be in assets like stocks, bonds, real estate, or even a new business.
          </p>
          <img 
            src="./invest.png" 
            alt="Financial growth" 
            className="img-fluid rounded shadow"
          />
        </div>

        <div className="col-md-6">
          <h3 className="text-primary">Why Should You Invest?</h3>
          <p>
            Investing helps beat inflation, builds wealth, secures your future, and supports long-term financial planning. It also creates opportunities to earn passive income.
          </p>
          <img 
            src="invest2.webp" 
            alt="Benefits of Investment" 
            className="img-fluid rounded shadow"
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <h3 className="text-info">Popular Investment Options</h3>

          <div className="mb-4">
            <h5>📈 Stocks</h5>
            <p>Stocks represent ownership in a company and offer high return potential. However, they can be volatile and carry risk based on market performance.</p>
          </div>

          <div className="mb-4">
            <h5>📊 Mutual Funds</h5>
            <p>Mutual funds pool money from multiple investors to invest in a diversified portfolio of stocks, bonds, or other securities, managed by professionals.</p>
          </div>

          <div className="mb-4">
            <h5>💰 Fixed Deposits</h5>
            <p>Fixed deposits (FDs) are low-risk investments offered by banks that provide a guaranteed return over a fixed period.</p>
          </div>

          <div className="mb-4">
            <h5>🧾 Bonds</h5>
            <p>Bonds are debt instruments where you lend money to a government or company in exchange for regular interest payments and return of principal at maturity.</p>
          </div>

          <div className="mb-4">
            <h5>🏠 Real Estate</h5>
            <p>Investing in property can provide rental income and capital appreciation. It's a long-term investment that requires significant capital.</p>
          </div>

          <div className="mb-4">
            <h5>🪙 Gold & Precious Metals</h5>
            <p>Gold is considered a safe-haven asset that retains value during market uncertainty. It can be bought in physical or digital form.</p>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-12">
          <h3 className="text-warning">Investment Tips for Beginners</h3>
          <ol className="list-group list-group-numbered shadow">
            <li className="list-group-item">
              <strong>Start early and invest regularly:</strong> The earlier you start, the more time your money has to grow through compounding.
            </li>
            <li className="list-group-item">
              <strong>Diversify your portfolio:</strong> Spread your investments across asset classes to manage risk effectively.
            </li>
            <li className="list-group-item">
              <strong>Understand the risk involved:</strong> Every investment has some level of risk—make sure you know yours before diving in.
            </li>
            <li className="list-group-item">
              <strong>Keep a long-term perspective:</strong> Don't panic during market dips. Long-term investing often yields better results.
            </li>
            <li className="list-group-item">
              <strong>Consult a financial advisor:</strong> If you're unsure, a certified advisor can help you create a sound investment plan.
            </li>
          </ol>
        </div>
      </div>

      <div className="row mt-5 mb-5">
        <div className="col-md-12">
          <h3 className="text-danger">Latest Investment News</h3>
          <div className="card shadow mb-3">
            <div className="card-body">
              <h5 className="card-title">Stock Market Reaches All-Time High</h5>
              <p className="card-text">The BSE Sensex surged to a record level this week, driven by positive global cues and strong corporate earnings reports.</p>
            </div>
          </div>
          <div className="card shadow">
            <div className="card-body">
              <h5 className="card-title">Gold Prices Continue to Rise</h5>
              <p className="card-text">Investors are turning to gold as a safe-haven asset amid global uncertainty and inflation fears.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Investments;
